<template>
    <li class="menu-section user-select-none">
        <h4 class="menu-text"><i v-if="icon" class="mr-2" :class="icon"></i>{{ label }}</h4>
    </li>
</template>

<script>

export default {
    props: {
        label: String,
        icon: String
    }
}
</script>
